import EmptyState from '../components/element/emptyState.vue'
import { listRequestState } from './listRequestState'

// Supply a shared default without replacing pages' loading/error/empty slots.
export function installTableEmptyState (ElementUI) {
  const render = ElementUI.Table.render
  ElementUI.Table.render = function (h) {
    let loading = false
    for (let vm = this; vm; vm = vm.$parent) {
      const directives = (vm.$vnode && vm.$vnode.data && vm.$vnode.data.directives) || []
      if (directives.some(directive => directive.name === 'loading' && directive.value)) {
        loading = true
        break
      }
    }
    const vnodeData = (this.$vnode && this.$vnode.data) || {}
    const classes = (vnodeData.staticClass || '') + ' ' + (typeof vnodeData.class === 'string' ? vnodeData.class : '')
    const route = this.$route && this.$route.fullPath
    const request = /(?:^|\s)admin-data-table(?:\s|$)/.test(classes) && route && listRequestState.routes[route]
    const pending = request && request.pending > 0
    // Explicit page empty/error slots remain authoritative after loading ends.
    if (!loading && !pending && (this.$slots.empty || this.$scopedSlots.empty)) return render.call(this, h)
    const previous = this.$slots.empty
    const previousScoped = this.$scopedSlots.empty
    delete this.$scopedSlots.empty
    this.$slots.empty = [h('div', { class: 'admin-default-empty' }, loading ? [] : pending ? [
      h('div', { class: 'admin-list-loading', attrs: { role: 'status' } }, [
        h('i', { class: 'el-icon-loading', attrs: { 'aria-hidden': 'true' } }),
        h('span', '正在加载…')
      ])
    ] : [
      h(EmptyState, { props: { title: request && request.failed ? '加载失败，请重试' : this.emptyText || '暂无数据' } })
    ])]
    try {
      return render.call(this, h)
    } finally {
      if (previous) this.$slots.empty = previous
      else delete this.$slots.empty
      if (previousScoped) this.$scopedSlots.empty = previousScoped
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/tableEmptyState.js